export default __webpack_public_path__ + "static/media/logoIconPng.1f9ff1ff.png";